// removed by extract-text-webpack-plugin
module.exports = {"loader":"_1mZJZ","load6":"_1qACZ","medium":"_3sDpo","mini":"_3sH5l"};


//////////////////
// WEBPACK FOOTER
// ./app/components/image-loader/image-loader.scss
// module id = 741
// module chunks = 3 4 5 6 7